import { tailwindOverride } from '@getsynapse/design-system';
import { CardType } from 'utils/customTypes';

import { ChartType } from 'types/store/normalized/insights/chartTypes';

import donutThumb from 'assets/insight-thumbs/donut.svg';
import hBarThumb from 'assets/insight-thumbs/h-bar.svg';
import hBarMultiThumb from 'assets/insight-thumbs/h-bar-multi.svg';
import hBarStackThumb from 'assets/insight-thumbs/h-bar-stack.svg';
import kpiThumb from 'assets/insight-thumbs/kpi.svg';
import lineThumb from 'assets/insight-thumbs/line.svg';
import lineMultiThumb from 'assets/insight-thumbs/line-multi.svg';
import vBarThumb from 'assets/insight-thumbs/v-bar.svg';
import vBarMultiThumb from 'assets/insight-thumbs/v-bar-multi.svg';
import vBarStackThumb from 'assets/insight-thumbs/v-bar-stack.svg';
import vBarStackLineThumb from 'assets/insight-thumbs/v-bar-stack-line.svg';
import { InsightCategory } from 'types/store/normalized/insights/InsightCatalogue';

export const CHART_THUMBNAILS = {
  [ChartType.DONUT]: donutThumb,
  [ChartType.H_BAR]: hBarThumb,
  [ChartType.H_BAR_MULTI]: hBarMultiThumb,
  [ChartType.H_BAR_STACK]: hBarStackThumb,
  [ChartType.KPI]: kpiThumb,
  [ChartType.LINE]: lineThumb,
  [ChartType.LINE_MULTI]: lineMultiThumb,
  [ChartType.V_BAR]: vBarThumb,
  [ChartType.V_BAR_MULTI]: vBarMultiThumb,
  [ChartType.V_BAR_STACK]: vBarStackThumb,
  [ChartType.V_BAR_STACK_LINE]: vBarStackLineThumb,
};

const classNamesMap: Record<string, string> = {
  [InsightCategory.CAPACITY_MANAGEMENT]: 'bg-mint-frost',
  [InsightCategory.REQUESTS]: 'bg-dusty-pink',
  [InsightCategory.PROJECTS]: 'bg-dusty-pink',
  [InsightCategory.TASKS]: 'bg-dusty-pink',
  [InsightCategory.USERS]: 'bg-dusty-pink',
  [InsightCategory.EVENTS]: 'bg-pale-peach',
};

export const renderChartThumbnail = (
  cardType: CardType,
  isExisting: boolean
) => {
  const thumbnail =
    CHART_THUMBNAILS[cardType.chartType] || CHART_THUMBNAILS[ChartType.KPI];

  return (
    <div
      className={tailwindOverride(
        `w-full flex justify-center items-center h-40 mb-2 ${
          classNamesMap[cardType.category]
        }`,
        {
          'bg-light-pastel-blue': isExisting,
        }
      )}
    >
      <img
        src={thumbnail}
        alt=''
        className={tailwindOverride('max-w-full max-h-full', {
          'opacity-50': isExisting,
        })}
      />
    </div>
  );
};
